// Vendor imports
const _ = require('lodash')
// Model imports
const {
  ARTICLE_HAS_MIX_CHANGE_PENDING,
  ARTICLE_LOADED,
  ARTICLE_MIXES_UPDATED
} = require('./actions')
const ArticleModelRecord = require('./record')

// eslint-disable-next-line complexity
function articleReducer(state, { type, payload }) {
  // Sanity check
  if (!payload || !(state instanceof ArticleModelRecord)) {
    return state
  }
  // Ignore actions that don't refer to this article
  if (state['url_id'] !== payload.urlId) {
    return state
  }
  switch (type) {
    case ARTICLE_HAS_MIX_CHANGE_PENDING:
      return state.merge({
        hasMix: ARTICLE_HAS_MIX_CHANGE_PENDING
      })
    case ARTICLE_LOADED:
      return state.mergeDeep(payload.article)
    case ARTICLE_MIXES_UPDATED:
      return state.merge({
        hasMix: !_.isEmpty(payload.mixIds)
      })
    default:
      return state
  }
}

module.exports = articleReducer
